import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import useUserInfo from "./useUserInfo";
import { CloseButton, ItemContainer, ItemLabel, ItemsContainer, ItemText } from "./styles";
import { OpenInNew } from "@material-ui/icons";
import { IoMdClose } from "react-icons/io";

export default function UserInfoModal({ userID, onClose }) {
  const { data, isLoading, error } = useUserInfo({ userID });

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose}>
      <CloseButton onClick={onClose}>
        <IoMdClose size="1.25em" />
      </CloseButton>
      <DialogTitle>
        Informações básicas do aluno
      </DialogTitle>
      <DialogContent>
        {isLoading && (
          <Box display="flex" justifyContent="center" alignItems="center" padding={8}>
            <CircularProgress size={48} style={{ color: "#ff7417"}} />
          </Box>
        )}
        {!isLoading && data && (
          <ItemsContainer>
            <ItemContainer>
              <ItemLabel>ID</ItemLabel>
              <ItemText>{data.id}</ItemText>
            </ItemContainer>
            <ItemContainer>
              <ItemLabel>Nome</ItemLabel>
              <ItemText>{data.name}</ItemText>
            </ItemContainer>
            <ItemContainer>
              <ItemLabel>Email</ItemLabel>
              <ItemText>{data.email}</ItemText>
            </ItemContainer>
          </ItemsContainer>
        )}
        {!isLoading && error && (
          <Box display="flex" justifyContent="center" alignItems="center" padding={8}>
            Houve um erro {error}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          href={`/admin/alunos/detalhes/${userID}`}
          target="_blank"
          variant="contained"
          color="primary"
          endIcon={<OpenInNew />}
        >
          Acessar perfil
        </Button>
      </DialogActions>
    </Dialog>
  )
}